import { AbstractControl, ValidationErrors } from '@angular/forms';

export const FilenameValidator = (control: AbstractControl): ValidationErrors | null => {
	const regex = /^[^\\/:*?"<>|]+$/;
	const value = control?.value;

	if (typeof value === 'string' && value === '')
		return { required: true }

	if (typeof value === 'string' && !regex.test(value)) 
		return { invalidCharacters: true };

	return null;
}
